<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      {{ $t('vie.Pag.Das.Bus.ste.FourthStep.text1') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>{{ $t('common_words.area') }}</label>
          <br />
          <el-select
            @change="selectAllFromSelect('model.areas_ids', areas)"
            clearable
            filterable
            multiple
            class="select-primary custom-width-select shadow-sm"
            v-model="model.areas_ids"
            size="large"
            :placeholder="`${$t('common_words.select')}... `"
          >
            <el-option
              v-for="option in areas"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SweetAlert from 'src/class/Alerts';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import { Axios } from 'src/class/Axios.js';

export default {
  data() {
    return {
      model: {
        areas_names: [],
        areas_ids: [],
      },
      areas: null,
    };
  },
  mixins: [MixinPermissions, mixinMasters],
  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.areas = this.concatAll(this.areas.splice(1));
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);

        let others = [];
        this.model.areas_ids.forEach((element) => {
          this.areas.forEach((item) => {
            if (element == item.id) {
              others.push(item.name);
            }
          });
        });

        this.$emit('fillBusinessForm', 'fourthStep', { areas_names: others });
        return res;
      });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Axios.getMasters('areas/assigned')
        .then((response) => {
          this.areas = this.concatAll(response.data.data);

          if (!sessionStorage.getItem('editForm') && this.areas.length == 1)
            this.model.areas_ids.push(this.areas[0].id);

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      editForm.areas.forEach((element) => {
        this.model.areas_ids.push(element.id);
      });
    }
  },
};
</script>
<style></style>
